import iro from "@jaames/iro";

export default class Primaries {
	constructor() {
		this.blockName = "primaries";
		this.passNames = [
			"Primaries-wheel-lift-Y",
			"Primaries-wheel-lift-RGB",
			"Primaries-wheel-gamma-Y",
			"Primaries-wheel-gamma-RGB",
			"Primaries-wheel-gain-Y",
			"Primaries-wheel-gain-RGB",
			"Primaries-wheel-offset-Y",
			"Primaries-wheel-offset-RGB",
			"Primaries-sliders-lift-Y",
			"Primaries-sliders-lift-RGB",
			"Primaries-sliders-gamma-Y",
			"Primaries-sliders-gamma-RGB",
			"Primaries-sliders-gain-Y",
			"Primaries-sliders-gain-RGB",
			"Primaries-sliders-offset-Y",
			"Primaries-sliders-offset-RGB",
		];
		this.curveNames = [
			"Primaries-Lift-Y",
			"Primaries-Lift-R",
			"Primaries-Lift-G",
			"Primaries-Lift-B",
			"Primaries-Gamma-Y",
			"Primaries-Gamma-R",
			"Primaries-Gamma-G",
			"Primaries-Gamma-B",
			"Primaries-Gain-Y",
			"Primaries-Gain-R",
			"Primaries-Gain-G",
			"Primaries-Gain-B",
			"Primaries-Offset-Y",
			"Primaries-Offset-R",
			"Primaries-Offset-G",
			"Primaries-Offset-B",
		];
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		const element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".control-selector__items-container > span")
			.on("click", (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock($(element)));
		$(element)
			.find(".colorwheel-container")
			.on("dblclick", e => this.resetColorWheel($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("dblclick", e => this.resetVerticalSlider($(e.currentTarget)));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find('.control-selector__items-container > span[data-control="wheels"]')
			.trigger("click", [false]);

		$(element)
			.find('.block-controls-container[data-control="wheels"] .slider-control')
			.on("input", e => this.sliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="wheels"] .slider-input-control')
			.on("change", e => this.sliderInputHandler($(e.currentTarget)));

		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("input", e => this.verticalSliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-input-control')
			.on("change", e => this.verticalSliderInputHandler($(e.currentTarget)));

		$(element)
			.find(".control-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				this.toggleControlSelector($(e.currentTarget));
			});

		UI.initKnob(element);

		blocks.add({
			name: "primaries",
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			curves: [],
			values: {
				wheels: {
					lift: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
					gamma: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
					gain: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
					offset: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
				},
				sliders: {
					lift: { Y: 0, R: 0, G: 0, B: 0 },
					gamma: { Y: 0, R: 0, G: 0, B: 0 },
					gain: { Y: 0, R: 0, G: 0, B: 0 },
					offset: { Y: 0, R: 0, G: 0, B: 0 },
				},
			},
			colorWheels: this.colorWheelsInit($(element)),
		});

		this.slidersInit($(element));
		blocks.createCurves(this.curveNames, blockNum);
	}

	addPasses() {
		let passes = [];
		this.passNames.forEach(passName => {
			let shaderPass = gpu.createCurveShaderPass(passName);
			gpu.addPassToComposer(shaderPass, "toMiddle");
			passes.push(shaderPass);
		});

		return passes;
	}

	colorWheelsInit($element) {
		let colorWheels = [];
		let colorWheelContainers = $element.find(".colorwheel-container");

		for (let i = 0; i < 4; i++) {
			let colorWheel = new iro.ColorPicker(colorWheelContainers[i], config.colorWheelOptions);
			colorWheel.on("color:change", colors => this.colorChangeHandler(colorWheelContainers[i], colors));
			colorWheels.push(colorWheel);
		}

		return colorWheels;
	}

	slidersInit($element) {
		$element.find('.block-controls-container[data-control="sliders"] .slider-control').slider({
			orientation: "vertical",
			width: 1,
			range: "min",
			min: -1,
			max: 1,
			step: 0.001,
			value: 0,
			change: (event, ui) => this.verticalSliderHandler(event, ui),
			slide: (event, ui) => this.verticalSliderHandler(event, ui),
		});

		$element.find('.block-controls-container[data-control="sliders"] .slider-control').each((index, sliderControl) => {
			let html = document.createElement("div");
			html.setAttribute("class", "slider-control-fill");
			$(sliderControl).append(html);
		});
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".control-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	controlSelection(selectedControl, animate = true) {
		let $blockOptions = $(selectedControl).closest(".block_options");
		$blockOptions.find(".control-selector__items-container").hide();
		$blockOptions.find(".selected-control-name").html($(selectedControl).html());
		if (animate) {
			$blockOptions.find(".block-controls-container").fadeOut(2);
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).fadeIn();
		} else {
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).show();
		}
	}

	colorChangeHandler(colorWheelElement, colors) {
		blocks.checkSwitchHandler($(colorWheelElement).closest(".adjustment-block"));
		lutify.setActiveBlock(
			parseInt(
				$(colorWheelElement)
					.closest(".adjustment-block")
					.attr("orignum")
			)
		);

		let controlName = $(colorWheelElement)
			.data("curve")
			.split("-")[0];
		// let controlCurve = $(colorWheelElement).data('curve').split('-')[1];
		let passIndex = $(colorWheelElement).data("pass-index");

		lutify.getActiveBlock().passes[passIndex].enabled = true;
		lutify.getActiveBlock().activePassIndex = passIndex;

		let newColors = {
			r: (colors.rgb.r / 255).toFixed(3),
			g: (colors.rgb.g / 255).toFixed(3),
			b: (colors.rgb.b / 255).toFixed(3),
		};

		lutify.getActiveBlock().values.wheels[controlName].R = newColors.r;
		lutify.getActiveBlock().values.wheels[controlName].G = newColors.g;
		lutify.getActiveBlock().values.wheels[controlName].B = newColors.b;

		if (!UI.mouse.knobDrag) {
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-R"]`)
				.val(newColors.r);
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-G"]`)
				.val(newColors.g);
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-B"]`)
				.val(newColors.b);
		}

		this[`${controlName}RGBCurve`]([colors.rgb.r, colors.rgb.g, colors.rgb.b]);
	}

	sliderHandler($sliderElement) {
		blocks.checkSwitchHandler($sliderElement.closest(".adjustment-block"));

		let controlName = $sliderElement.data("curve").split("-")[0];
		let controlCurve = $sliderElement.data("curve").split("-")[1];
		let passIndex = $sliderElement.data("pass-index");

		lutify.getActiveBlock().passes[passIndex].enabled = true;
		lutify.getActiveBlock().activePassIndex = passIndex;
		lutify.getActiveBlock().values.wheels[controlName].Y = $sliderElement.val();

		$sliderElement
			.closest(".control-container")
			.find(`.slider-input-control[data-curve="${controlName}-Y"]`)
			.val($sliderElement.val());
		this[`${controlName}${controlCurve}Curve`]($sliderElement.val());
	}

	sliderInputHandler($sliderInputElement) {
		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));

		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];
		let passIndex = $sliderInputElement.data("pass-index");

		lutify.getActiveBlock().passes[passIndex].enabled = true;
		lutify.getActiveBlock().activePassIndex = passIndex;

		if ($sliderInputElement.val() > parseFloat($sliderInputElement.attr("max"))) $sliderInputElement.val($sliderInputElement.attr("max"));
		if ($sliderInputElement.val() < parseFloat($sliderInputElement.attr("min"))) $sliderInputElement.val($sliderInputElement.attr("min"));

		lutify.getActiveBlock().values.wheels[controlName][controlCurve] = $sliderInputElement.val();

		// slider R,G,B
		if (controlCurve == "R" || controlCurve == "G" || controlCurve == "B") {
			let colors = {
				r: (
					parseFloat(
						$sliderInputElement
							.closest(".control-container")
							.find(`.slider-input-control[data-curve=${controlName}-R]`)
							.val()
					) * 255
				).toFixed(3),
				g: (
					parseFloat(
						$sliderInputElement
							.closest(".control-container")
							.find(`.slider-input-control[data-curve=${controlName}-G]`)
							.val()
					) * 255
				).toFixed(3),
				b: (
					parseFloat(
						$sliderInputElement
							.closest(".control-container")
							.find(`.slider-input-control[data-curve=${controlName}-B]`)
							.val()
					) * 255
				).toFixed(3),
			};

			if (controlName == "lift") lutify.getActiveBlock().colorWheels[0].color.rgb = colors;
			else if (controlName == "gamma") lutify.getActiveBlock().colorWheels[1].color.rgb = colors;
			else if (controlName == "gain") lutify.getActiveBlock().colorWheels[2].color.rgb = colors;
			else if (controlName == "offset") lutify.getActiveBlock().colorWheels[3].color.rgb = colors;
		}

		// slider Y
		else {
			let $sliderControlElement = $sliderInputElement.closest(".control-container").find(`.slider-control[data-curve="${controlName}-Y"]`);
			$sliderControlElement.val($sliderInputElement.val());
			$sliderControlElement.trigger("input");
		}
	}

	verticalSliderHandler(event, ui) {
		let $sliderControlElement = $(event.target);
		let controlName = $sliderControlElement.data("curve").split("-")[0];
		let controlCurve = $sliderControlElement.data("curve").split("-")[1];
		let passIndex = $sliderControlElement.data("pass-index");

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = ui.value;
		lutify.getActiveBlock().activePassIndex = passIndex;
		lutify.getActiveBlock().passes[passIndex].enabled = true;

		if (controlCurve == "R" || controlCurve == "G" || controlCurve == "B") {
			let valueR = lutify.getActiveBlock().values.sliders[controlName]["R"];
			let valueG = lutify.getActiveBlock().values.sliders[controlName]["G"];
			let valueB = lutify.getActiveBlock().values.sliders[controlName]["B"];
			this[`${controlName}RGBCurve`]([valueR, valueG, valueB], false);
		} else {
			// curve Y
			this[`${controlName}${controlCurve}Curve`](lutify.getActiveBlock().values.sliders[controlName][controlCurve]);
		}

		let $sliderInputElement = $sliderControlElement
			.closest(".control-container")
			.find(`.slider-input-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderInputElement.val(ui.value);

		this.updateSliderUI($(event.target).closest(".slider-control"), ui.value);
		blocks.checkSwitchHandler($(event.target).closest(".adjustment-block"));
	}

	verticalSliderInputHandler($sliderInputElement) {
		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = $sliderInputElement.val();

		let $sliderControlElement = $sliderInputElement
			.closest(".control-container")
			.find(`.slider-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderControlElement.slider("value", $sliderInputElement.val());

		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));
	}

	liftYCurve(liftValue) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		if (liftValue > 0) {
			curve.points.push({ x: 0.0, y: 0.0 + liftValue * 0.003921 * 128 });
			curve.points.push({ x: 1.0, y: 1.0 });
		} else {
			curve.points.push({ x: 0.0 + Math.abs(liftValue) * 0.003921 * 128, y: 0.0 });
			curve.points.push({ x: 1.0, y: 1.0 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPULiftY(curve.rgb);
	}

	liftRGBCurve(liftValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[1].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[2].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[3].colorCurve;

		liftValues.forEach((liftValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				liftValue = 255 - liftValue;
				curves[index].points.push({ x: 0.0 + (liftValue / 255) * 0.003921 * 128, y: 0.0 });
				curves[index].points.push({ x: 1.0, y: 1.0 });
			}

			// For sliders
			else {
				if (liftValue > 0) {
					curves[index].points.push({ x: 0.0, y: 0.0 + liftValue * 0.003921 * 128 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				} else {
					curves[index].points.push({ x: 0.0 + Math.abs(liftValue) * 0.003921 * 128, y: 0.0 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPULiftRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	gammaYCurve(gammaValue) {
		let curve = lutify.getActiveBlock().curves[4].colorCurve;
		curve.points = [];

		if (gammaValue >= 0) {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.09, y: 0.09 + gammaValue * 0.532 });
			curve.points.push({ x: 1.0, y: 1.0 });
		} else if (gammaValue < 0) {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.25 + Math.abs(gammaValue) * 0.504, y: 0.25 });
			curve.points.push({ x: 1.0, y: 1.0 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUGammaY(curve.rgb);
	}

	gammaRGBCurve(gammaValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[5].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[6].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[7].colorCurve;

		gammaValues.forEach((gammaValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				gammaValue = 255 - gammaValue;
				curves[index].points.push({ x: 0.0, y: 0.0 });
				curves[index].points.push({ x: 0.25 + (gammaValue / 255) * 0.504, y: 0.25 });
				curves[index].points.push({ x: 1.0, y: 1.0 });
			}

			// For sliders
			else {
				if (gammaValue >= 0) {
					curves[index].points.push({ x: 0.0, y: 0.0 });
					curves[index].points.push({ x: 0.09, y: 0.09 + gammaValue * 0.532 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				} else if (gammaValue < 0) {
					curves[index].points.push({ x: 0.0, y: 0.0 });
					curves[index].points.push({ x: 0.25 + Math.abs(gammaValue) * 0.504, y: 0.25 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUGammaRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	gainYCurve(gainVal) {
		let curve = lutify.getActiveBlock().curves[8].colorCurve;
		curve.points = [];

		if (gainVal > 0) {
			curve.points.push({ x: 0, y: 0.0 });
			curve.points.push({ x: 1.0 - gainVal * 0.003921 * 128, y: 1.0 });
		} else {
			curve.points.push({ x: 0, y: 0 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(gainVal) * 0.003921 * 128 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUGainY(curve.rgb);
	}

	gainRGBCurve(gainValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[9].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[10].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[11].colorCurve;

		gainValues.forEach((gainValue, index) => {
			curves[index].points = [];

			// For Wheels
			if (calcValue) {
				gainValue = 255 - gainValue;
				curves[index].points.push({ x: 0, y: 0 });
				curves[index].points.push({ x: 1.0, y: 1.0 - (gainValue / 255) * 0.003921 * 128 });
			}

			// For sliders
			else {
				if (gainValue > 0) {
					curves[index].points.push({ x: 0, y: 0.0 });
					curves[index].points.push({ x: 1.0 - gainValue * 0.003921 * 128, y: 1.0 });
				} else {
					curves[index].points.push({ x: 0, y: 0 });
					curves[index].points.push({ x: 1.0, y: 1.0 - Math.abs(gainValue) * 0.003921 * 128 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUGainRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	offsetYCurve(offsetVal) {
		let curve = lutify.getActiveBlock().curves[12].colorCurve;
		curve.points = [];

		if (offsetVal > 0) {
			curve.points.push({ x: 0.0, y: offsetVal * 0.003921 * 128 });
			curve.points.push({ x: 1.0 - Math.abs(offsetVal) * 0.003921 * 128, y: 1.0 });
		} else {
			curve.points.push({ x: Math.abs(offsetVal) * 0.003921 * 128, y: 0.0 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(offsetVal) * 0.003921 * 128 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUOffsetY(curve.rgb);
	}

	offsetRGBCurve(offsetValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[13].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[14].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[15].colorCurve;

		offsetValues.forEach((offsetValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				offsetValue = 255 - offsetValue;
				curves[index].points.push({ x: (offsetValue / 255) * 0.003921 * 128, y: 0.0 });
				curves[index].points.push({ x: 1.0, y: 1.0 - (offsetValue / 255) * 0.003921 * 128 });
			}

			// For sliders
			else {
				if (offsetValue > 0) {
					curves[index].points.push({ x: 0.0, y: offsetValue * 0.003921 * 128 });
					curves[index].points.push({ x: 1.0 - Math.abs(offsetValue) * 0.003921 * 128, y: 1.0 });
				} else {
					curves[index].points.push({ x: Math.abs(offsetValue) * 0.003921 * 128, y: 0.0 });
					curves[index].points.push({ x: 1.0, y: 1.0 - Math.abs(offsetValue) * 0.003921 * 128 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUOffsetRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	callGPULiftY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPULiftRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUGammaY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUGammaRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUGainY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUGainRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUOffsetY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUOffsetRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	resetBlock($element) {
		let $sliderInputControls = $element.find(".slider-input-control");
		$sliderInputControls.each(function() {
			$(this).val($(this).data("default-value"));
		});
		$sliderInputControls.trigger("change");
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
	}

	resetColorWheel($colorWheelContainer) {
		// let controlName = $colorWheelContainer.data('curve').split('-')[0];
		let controlCurve = $colorWheelContainer.data("curve").split("-")[1];
		let passIndex = $colorWheelContainer.data("pass-index");
		let $sliderInputControls = $colorWheelContainer.closest(".control-container").find(".slider-input-control");

		$sliderInputControls.each(function(i) {
			if (i !== 0) {
				$(this).val($(this).data("default-value"));
				$(this).trigger("change");
			}
		});

		lutify.getActiveBlock().passes[passIndex].enabled = false;
	}

	resetVerticalSlider($slider) {
		$slider.slider("value", 0);

		let targetCurveName = $slider.data("curve").split("-")[0];
		let targetCurve = $slider.data("curve").split("-")[1];
		let passIndex = $slider.data("pass-index");

		if (targetCurve == "Y") {
			lutify.getActiveBlock().passes[passIndex].enabled = false;
		} else {
			if (
				lutify.getActiveBlock().values.sliders[targetCurveName].R == 0 &&
				lutify.getActiveBlock().values.sliders[targetCurveName].G == 0 &&
				lutify.getActiveBlock().values.sliders[targetCurveName].B == 0
			) {
				lutify.getActiveBlock().passes[passIndex].enabled = false;
			}
		}
	}

	updateSliderUI($slider, sliderValue) {
		let $sliderControlElementHeight = $slider.height();
		let sliderControlFillHeight = Math.abs(($sliderControlElementHeight * sliderValue) / 2);
		let $sliderControlFillElement = $slider.find(".slider-control-fill");
		$sliderControlFillElement.css("height", `${sliderControlFillHeight}px`);

		if (sliderValue > 0) {
			$sliderControlFillElement.css({
				bottom: "50%",
				top: "initial",
			});
		} else if (sliderValue < 0) {
			$sliderControlFillElement.css({
				top: "50%",
				bottom: "initial",
			});
		}
	}

	applyChanges($block, values) {
		Object.keys(values).forEach(control => {
			Object.keys(values[control]).forEach(curve => {
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-Y"]`)
					.val(values[control][curve].Y);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-R"]`)
					.val(values[control][curve].R);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-G"]`)
					.val(values[control][curve].G);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-B"]`)
					.val(values[control][curve].B);
			});
		});

		$block.find('.block-controls-container[data-control="wheels"] .slider-input-control').trigger("change");
		$block.find('.block-controls-container[data-control="sliders"] .slider-input-control').trigger("change");
	}
}
